import EfCheckInActivities from '@elem/ui/ef-check-in-activities';
import EfSpec from '@elem/ui/ef-spec';
import EfNeedLoginLink from '@elem/ui/ef-need-login-link';
import { useEffect, useState } from 'react';
import { useProductStore } from '../../../ProductProvider';
import styles from './index.module.scss';
import TextComp from './TextComp';
import { getIsLogin } from '@/utils/cookie';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { systemTime } = useProductStore();
    const [isLogin, setIsLogin] = useState(false);
    const { locale, pathname } = getLocal();
    const { t } = useLang('theProduct.SectionF');

    const saveScrollPosition = () => sessionStorage.setItem('scrollPosition', String(document.documentElement.scrollTop));

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo({
                top: Number(scrollPosition),
                behavior: 'smooth',
            });
            sessionStorage.removeItem('scrollPosition');
        }
        return () => {
            sessionStorage.removeItem('scrollPosition');
        };
    }, []);

    return (
        <div className={styles.TheComp} id="section-SectionF">
            <div className="SectionF-in">
                <EfSpec />
                <EfCheckInActivities className="SectionF-check" systemTime={systemTime} callback={() => setIsLogin(true)} />
                {!isLogin && (
                    <div className="SectionF-line2">
                        {t.rich('tips_2', {
                            strong: (text: string) => (
                                <EfNeedLoginLink
                                    text={text && text[0]}
                                    entry_position={7}
                                    href={`/${locale}${pathname}`}
                                    onClick={saveScrollPosition}
                                ></EfNeedLoginLink>
                            ),
                        })}
                    </div>
                )}
                <TextComp />
            </div>
        </div>
    );
}
